export default __webpack_public_path__ + "static/media/HOAKS-TOOLS-1.97e1d7f0.png";